module.exports = __webpack_public_path__ + "img/subt.c21710ee.svg";